import { Outlet } from 'react-router';
import { CookieConsent } from '@/components/CookieConsent';
import { Header } from '@/components/Header';
import { RequireAuth } from '@/components/RequireAuth';
import { RequireTerms } from '@/components/RequireTerms';
import { SessionWatcher } from '@/components/SessionWatcher';
import { SiteStandingBanner } from '@/components/SiteStandingBanner';
import { StaleBundleNotice } from '@/components/StaleBundleNotice';
import { VdbRebuildWatcher } from '@/components/VdbRebuildWatcher';
import { LoadJobToasts } from '@/components/LoadJobToasts';
import { LoadJobsProvider } from '@/components/LoadJobsProvider';
import { analyticsMeasurementId } from '@/lib/auth-config';
import { useDevBanner } from '@/lib/usePages';

function DevBanner() {
  const banner = useDevBanner();
  if (!banner.data) return null;
  return (
    <div className="bg-tres-warning px-4 py-1.5 text-center text-xs font-semibold text-white">
      {banner.data}
    </div>
  );
}

export function Layout() {
  return (
    <LoadJobsProvider>
      <div className="flex min-h-full flex-col">
        {/* First in the DOM so a keyboard user reaches the choice before the
            page, though it is drawn fixed at the bottom. */}
        <CookieConsent measurementId={analyticsMeasurementId()} />
        <StaleBundleNotice />
        <DevBanner />
        <SiteStandingBanner />
        <Header />
        <main className="flex-1">
          <RequireAuth>
            <RequireTerms>
              <Outlet />
            </RequireTerms>
          </RequireAuth>
        </main>
        {/* Idle-timeout modal + forced-signout banner. Sits outside the
            RequireAuth boundary so the "your account signed in elsewhere"
            banner can still surface after a forced sign-out. */}
        <SessionWatcher />
        {/* Refetch VDB-backed reads when a server-side rebuild finishes, so a
            load doesn't leave pre-load data cached while the build runs. */}
        <VdbRebuildWatcher />
        {/* Completion notices for background load jobs — visible on any page
            the user navigates to while a load runs. */}
        <LoadJobToasts />
      </div>
    </LoadJobsProvider>
  );
}
